import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {Set} from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import {default as Tooltip, TOOLTIP_POSITION_RIGHT} from 'components/Tooltip';
import StylesheetLink from 'components/StylesheetLink';
import {stylesheetUrl} from '../utils/typefaces';
import {TYPEFACE_PREVIEW_SPECIMEN} from '../settings';

export default createReactClass({
  propTypes: {
    typefaces: ImmutablePropTypes.iterable.isRequired,
    workingSetTypefaces: ImmutablePropTypes.iterable.isRequired,
    onTypefaceSelected: PropTypes.func.isRequired,
    onTypefaceDeselected: PropTypes.func.isRequired,
  },

  mixins: [ImmutableRenderMixin],

  getInitialState() {
    return {
      focusedTypeface: null,
      loadedStylesheetsFor: Set(),
    };
  },

  renderFamily(family, typefaces, includedTypefaceIds) {
    const {workingSetTypefaces} = this.props;
    const handleFocusNothing = (typeface) => {
      this.setState({focusedTypeface: null});
    };
    const typefacesElements = typefaces.map((typeface) => {
      const isIncluded = includedTypefaceIds.includes(typeface.id);
      const handleClicked = (event) => {
        event.preventDefault();

        if (isIncluded) {
          this.props.onTypefaceDeselected(workingSetTypefaces.find((i) => i.typeface === typeface.id));
        } else {
          this.props.onTypefaceSelected(typeface);
        }
      };
      const handleFocusTypeface = () => {
        this.setState({focusedTypeface: typeface});
      };
      const popover = (this.state.focusedTypeface === typeface) ?
        <Tooltip
          content={`${(isIncluded) ? 'Remove' : 'Add'} ${typeface.weight} ${typeface.style}`}
          icon={(isIncluded) ? 'ficon-times-circle' : 'ficon-plus-circle'}
          position={TOOLTIP_POSITION_RIGHT}
        /> : null;
      return (
        <a
          key={`typeface-${typeface.id}`}
          href="#"
          className={classnames('typeface', {active: isIncluded})}
          onClick={handleClicked}
          onMouseEnter={handleFocusTypeface}
          onMouseLeave={handleFocusNothing}
          style={{position: 'relative'}}
        >
          {popover}
          <span style={{fontFamily: typeface.family, fontWeight: typeface.weight, fontStyle: typeface.style}} className="specimen">{TYPEFACE_PREVIEW_SPECIMEN}</span>
        </a>
      );
    });
    const stylesheetLoaded = this.state.loadedStylesheetsFor.has(family);
    const handleStylesheetLoaded = () => {
      this.setState({
        loadedStylesheetsFor: this.state.loadedStylesheetsFor.add(family),
      });
    };

    return (
      <div>
        <StylesheetLink
          onLoaded={handleStylesheetLoaded}
          href={stylesheetUrl(typefaces)}
        />
        <div style={{position: 'relative', minHeight: '5rem'}}>
          {(stylesheetLoaded) ? typefacesElements : null}
        </div>
      </div>
    );
  },

  render() {
    const {typefaces, workingSetTypefaces} = this.props;
    const includedTypefaceIds = workingSetTypefaces.map((workingSetTypeface) => workingSetTypeface.typeface);
    const typefaceElements = typefaces
      .groupBy((typeface) => typeface.family)
      .map((typefacesForFamily, family) => {
        return (
          <div key={`family-${family}`} className="typefamily-preview">
            <div className="gg gg-bottom">
              <div className="gg-col">
                <h2 className="m-xs-a-0">{family}</h2>
              </div>
              <div className="gg-col text-xs-right">
                <div className="text-muted">
                  {family} · {typefacesForFamily.size} {(typefacesForFamily.size === 1) ? 'Style' : 'Styles'}
                </div>
              </div>
            </div>
            <hr className="m-xs-t-md m-xs-b-md" />
            {this.renderFamily(family, typefacesForFamily, includedTypefaceIds)}
          </div>
        );
      })
      .flatten(1)
      .values();

    return (
      <div>
        {[...typefaceElements]}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/TypefaceExample.js